import { sharedApi } from '@/shared/api/shared.api';
import { useCheckImagesSizes } from '@/shared/lib/hooks/useCheckImageSizes';
import { useAppDispatch } from '@/shared/model';
import { setNotification } from '@/shared/model/appSlice';
import DropInput from '@/shared/ui/DropInput/DropInput';
import type { FileWithPreview } from '@/shared/ui/Input/Input';

interface Props {
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

export const InputModalImage = ({ value, onChange, error }: Props) => {
  const checkImages = useCheckImagesSizes();
  const dispatch = useAppDispatch();

  const handleImageUpload = async ([files]: FileWithPreview[][]) => {
    if (!files || !files.length) return;

    const check = async (w: number, h: number) =>
      !(await checkImages({ files, minWidth: w, minHeight: h }));

    const ok16x9 = await check(1600, 900);
    const ok1x1 = await check(1000, 1000);
    const ok4x5 = await check(800, 1000);

    if (!ok16x9 && !ok1x1 && !ok4x5) {
      dispatch(
        setNotification({
          variant: 'error',
          value: 'Ошибка при загрузке (маленький размер)',
        })
      );
      return;
    }

    const formData = new FormData();
    formData.append('file', files[0]);
    const response = await sharedApi.createFile(formData);
    onChange(response.data.file);
  };

  return (
    <DropInput
      title='Фото'
      htmlFor='modal.image'
      value={value || ''}
      files={value ? [value] : ([] as unknown as File[])}
      setFiles={handleImageUpload}
      onDelete={() => onChange('')}
      withIcon
      sizes='(16x9, 1x1, 4x5)'
      error={error}
    />
  );
};
